<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Input from 'dashboard/components-next/input/Input.vue';
import TextArea from 'dashboard/components-next/textarea/TextArea.vue';
import Avatar from 'dashboard/components-next/avatar/Avatar.vue';

defineProps({
  avatarUrl: { type: String, default: '' },
});

const emit = defineEmits(['upload', 'deleteAvatar']);

const name = defineModel('name', { type: String, default: '' });
const description = defineModel('description', { type: String, default: '' });

const { t } = useI18n();
const dialogRef = ref(null);

const open = () => dialogRef.value?.open();
const close = () => dialogRef.value?.close();

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    width="md"
    :title="t('AGENT_BOTS.VISUAL_BUILDER.SETTINGS.TITLE')"
    :description="t('AGENT_BOTS.VISUAL_BUILDER.SETTINGS.DESCRIPTION')"
    :show-cancel-button="false"
    :confirm-button-label="t('AGENT_BOTS.VISUAL_BUILDER.SETTINGS.DONE')"
    @confirm="close"
  >
    <div class="flex flex-col gap-4">
      <Avatar
        :src="avatarUrl"
        :name="name"
        :size="64"
        allow-upload
        icon-name="i-lucide-bot-message-square"
        @upload="emit('upload', $event)"
        @delete="emit('deleteAvatar')"
      />
      <Input v-model="name" :label="t('AGENT_BOTS.VISUAL_BUILDER.BOT_NAME')" />
      <TextArea
        v-model="description"
        :label="t('AGENT_BOTS.VISUAL_BUILDER.BOT_DESCRIPTION')"
        :rows="3"
      />
    </div>
  </Dialog>
</template>
